import { snapshot } from 'valtio'
import { recurringPaymentProxy } from '../../../../shared/proxies/recurringPaymentProxy'
import { executeRpOccurrenceSkip } from './modals/executeRpOccurrenceSkip'

export const handleSkipUnskipPayment = async (e: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
  e.preventDefault()
  const { recurringPayment } = snapshot(recurringPaymentProxy)

  if (!recurringPayment) {
    return
  }

  await executeRpOccurrenceSkip({ id: recurringPayment.id.toString(), skipPayment: recurringPayment.skipNextPayment })
}
